import { findClosestValueIndex, roundValueToStep } from '../../helpers';
export function useSliderHelpers(_ref) {
  let {
    props,
    marks
  } = _ref;
  const {
    step,
    min
  } = props;
  const roundValue = value => {
    if (step) {
      return roundValueToStep(value, step, min);
    }
    const marksValues = marks.map(mark => mark.value);
    const closestIndex = findClosestValueIndex(marksValues, value);
    return marksValues[closestIndex];
  };
  return {
    roundValue
  };
}